import VerivoxTabsClass from '../App/VerivoxTabs';
import starRating       from './starRating';

export default ($item) => {
    let id = $item.data('id');
    let rel = $item.data('rel');
    let curlURL = $item.data('curl-url');
    let url = $('[data-tabs-route]').data('tabs-route');

    let options = {
        type: 'POST',
        url: url,
        data: {
            id: id,
            rel: rel,
            curl: curlURL
        }
    };

    let VerivoxTabs = new VerivoxTabsClass();
    let $priceTab = $item.find('div[id*=child-tab-price-]');
    let $conditionsTab = $item.find('div[id*=child-tab-conditions-]');
    let $energyTab = $item.find('div[id*=child-tab-energy-]');
    let $providerTab = $item.find('div[id*=child-tab-provider-]');

    $.ajax(options).done(request => {
        let priceTabContent = VerivoxTabs.preparePriceTab(request);
        $priceTab.html(priceTabContent);

        let conditionTabContent = VerivoxTabs.prepareConditionsTab(request.contractDetails);
        $conditionsTab.html(conditionTabContent);

        // Gas has no energy tab in the template at all
        if ($energyTab.length) {
            $energyTab.html(VerivoxTabs.prepareEnergyTab(request));
        }

        let providerTabContent = VerivoxTabs.prepareProviderTab(request);
        $providerTab.html(providerTabContent);

        starRating();
    }).fail(request => {
        console.warn(request);
    });
};
